import {Base} from "@/api/Base"

export class PaymentListByIdAdv extends Base {
    path = "payment/listByIdAdv"
}